export default {
    'cauk-dev.dhc-cloud-dev.com': 'https://cauk.api.dhc-saas-dev.com/api/v1/', // development cauk for europe
    'mbc-1000.eu': 'https://cauk.api.mybattery365.eu/api/v1/', // production cauk for europe
    'www.mbc-1000.eu': 'https://cauk.api.mybattery365.eu/api/v1/', // production cauk for europe
};
